import React, { forwardRef } from "react"
import { Input, Select, Calendar, CheckBox, TreeSelect } from "components/Inputs"
import { useCallsheetInputValidation } from "../hooks/useCallsheetInputValidation"

const WrappedInput = forwardRef(({ name, type = "input", options = [], validation, maxLength, className = "w-1/2", ...rest }, ref) => {
  const sharedProps = {
    className,
    name: `call-sheet-${name}`,
    theme: "callSheet",
    id: name,
    maxLength,
    ...rest,
  }
  if (type !== "treeSelect") delete sharedProps.onOpenChange

  const { error, onKeyDownValidated, onPasteValidated } = useCallsheetInputValidation({
    maxLength,
    validation,
    value: rest?.value,
    onKeyDown: rest?.onKeyDown,
    onPaste: rest?.onPaste,
  })

  switch (type) {
    case "select":
      return <Select {...sharedProps} options={options} error={error} ref={ref} />
    case "calendar":
      return <Calendar {...sharedProps} error={error} ref={ref} minDate={new Date().setFullYear(1900)} maxDate={new Date()} />
    case "checkbox":
      return <CheckBox {...sharedProps} error={error} ref={ref} />
    case "treeSelect":
      return <TreeSelect treeDefaultExpandAll {...sharedProps} options={options} error={error} ref={ref} />
    default:
      return (
        <Input
          {...sharedProps}
          ref={ref}
          type="text"
          label={`${rest?.label} ${maxLength ? `(${rest?.value ? rest?.value?.length : 0}/${maxLength})` : ""}`}
          error={error}
          onKeyDown={onKeyDownValidated}
          onPaste={onPasteValidated}
        />
      )
  }
})
WrappedInput.displayName = "WrappedInput"

export default WrappedInput
